// extracted by mini-css-extract-plugin
export default {"summaryCard":"ProgramDetails-module__summaryCard--bUCDH","programInfo":"ProgramDetails-module__programInfo--RB0QC"};